import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../contexts/AdminAuthContext";
import { Loader2 } from "lucide-react";

const AdminProtectedRoute = ({ children }) => {
  const { user } = useAdminAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <Loader2 className="w-8 h-8 animate-spin text-amber-500" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};

export default AdminProtectedRoute;
